import React from 'react';
import type { ComponentProps } from 'react';
import { Switch as ReactSwitch, Redirect as ReactRedirect } from 'react-router';
import { Link as ReactLink, matchPath as reactMatchPath } from 'react-router-dom';
import type { LinkProps } from 'react-router-dom';

import {
  Router as SharedRouter,
  Route as SharedRoute,
  withRouter as sharedWithRouter,
  MemoryRouter as SharedMemoryRouter,
  HashRouter as SharedHashRouter,
} from '@bingads-webui-react/router';

export type RouterProps = ComponentProps<typeof SharedRouter>;

export type ParseRoute = NonNullable<RouterProps['parseRoute']>;

export type SharedRouteProps = ComponentProps<typeof SharedRoute>;

export type MemoryRouterProps = ComponentProps<typeof SharedMemoryRouter>;

export type MemoryRouterLocationDescriptor = Extract<NonNullable<MemoryRouterProps['initialEntries']>[number], object>;

export type HashRouterProps = ComponentProps<typeof SharedHashRouter>;

export type SharedRouterComponentProps = RouterProps | SharedRouteProps | MemoryRouterProps | HashRouterProps;

export type SharedWithRouter = typeof sharedWithRouter;

/*
 * @bingads-webui-react/router elements
 */
// @aiContributed-MAPFuse-2026-06-06
export const Router = (props: RouterProps) => <SharedRouter {...props} />;

export const Route = (props: SharedRouteProps) => <SharedRoute {...props} />;

export const withRouter: SharedWithRouter = sharedWithRouter;

export const MemoryRouter = (props: MemoryRouterProps) => <SharedMemoryRouter {...props} />;

export const HashRouter = (props: HashRouterProps) => <SharedHashRouter {...props} />;

/*
 * react-router elements
 */
export const Switch = ReactSwitch;

export const Redirect = ReactRedirect;

/*
 * react-router-dom elements
 */
export const Link = ReactLink;

export type { LinkProps };

export const matchPath = reactMatchPath;
